<template>
  <div class="publicity">
    <!-- <Top :path="path" /> -->
    <div class="top">
      <div class="back" @click="back">
        <i class="el-icon-arrow-left" /> 返回
      </div>
      <div class="path"><i class="el-icon-location" /> 首页-宣传内容列表</div>
    </div>
    <div class="publicitycont">
      <div class="uploadingbtn" @click="release">
        <i class="el-icon-upload2" /> 发布
      </div>
      <div style="clear: both" />
      <div class="wire" />
      <div class="uploadinglistbox">
        <div
          class="uploadinglist"
          v-for="item in publicitylistdata"
          :key="item.gid"
        >
          <div class="uploadinglistImg"></div>
          <div class="uploadinglisttime">{{ item.releasetime }}</div>
          <div class="uploadinglisttitle">{{ item.title }}</div>
          <div class="uploadinglistcont" @click="getparticulars(item.gid)">
            {{ item.content }}
          </div>
          <div class="uploadinglistcont" style="text-align: right">
            <i
              style="color: var(--themeColor); font-size: 16px"
              class="el-icon-delete-solid"
              @click="delpublicity(item.gid)"
            ></i>
          </div>
        </div>
      </div>
      <el-dialog
        title="详情"
        :visible.sync="centerDialogVisible"
        width="50%"
        center
      >
        <div class="dialogtitle">{{ particularsdata.title }}</div>
        <div class="dialogcont">{{ particularsdata.content }}</div>
        <div class="dialogimg">
          <img :src="particularsdata.imgurl" alt />
        </div>
        <div class="dialogcont">{{ particularsdata.releasetime }}</div>
      </el-dialog>
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";
import { APIMAP } from "@/constants/apiConstants";
import { getServerData } from "@/utils/fetchData";
export default {
  name: "publicity",
  data() {
    return {
      centerDialogVisible: false,
      publicitylistdata: [],
      particularsdata: [],
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    this.publicitylist();
  },
  methods: {
    back() {
      this.$router.push({ name: "HomePage" });
    },
    release() {
      this.$router.push({ name: "release" });
    },
    delpublicity(id) {
      this.$confirm("确认删除？")
        .then(() => {
          this.del(id);
        })
        .catch(() => {
          console.log(12);
        });
    },
    async del(id) {
      try {
        const res = await getServerData(
          APIMAP.UPRELEASE,
          {
            gid: id,
          },
          "delete"
        );
        if (res == 1) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.publicitylist();
        } else {
          this.$message({
            type: "success",
            message: "删除失败!",
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => {
          console.log(12);
        });
    },
    async publicitylist() {
      try {
        const res = await getServerData(
          APIMAP.UPRELEASE,
          {
            pid: this.userInfo.platformid,
          },
          "get"
        );
        console.log("宣传列表", res);
        this.publicitylistdata = res.rows;
      } catch (e) {
        console.log(e);
      }
    },
    async getparticulars(gid) {
      try {
        const res = await getServerData(
          APIMAP.UPRELEASE + `/:${this.userInfo.gid}`,
          {
            gid: gid,
          },
          "get"
        );
        console.log("宣传详情", res);
        this.centerDialogVisible = true;
        this.particularsdata = res;
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.publicity {
  background-color: #f5f6fd;
  padding: 17px 19px;
  height: calc(100vh - 100px);
  width: 100%;
  .top {
    height: 49px;
    background: white;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #99a9ba;
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    box-shadow: 0px 6px 14px 0px rgba(127, 170, 217, 0.12);
    .back {
      margin-left: 19px;
      margin-top: 15px;
      display: inline-block;
      cursor: pointer;
    }
    .path {
      margin-left: 19px;
      margin-top: 15px;
      display: inline-block;
    }
  }
  .publicitycont {
    height: calc(100vh - 195px);
    margin-top: 9px;
    background: white;
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Regular;
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    box-shadow: 0px 6px 14px 0px rgba(127, 170, 217, 0.12);
    padding: 18px;
    .uploadingbtn {
      width: 55px;
      height: 23px;
      border: 1px solid var(--themeColor);
      border-radius: 4px;
      text-align: center;
      line-height: 23px;
      color: var(--themeColor);
      cursor: pointer;
      float: right;
      margin-right: 9px;
      overflow: hidden;
    }
    .wire {
      margin-top: 9px;
      border: 1px solid rgba(226, 229, 236, 0.6);
    }
    .uploadinglistbox {
      overflow: auto;
      height: 743px;
    }
    .dialogtitle {
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 900;
      color: #2c3a50;
      letter-spacing: 2px;
    }
    .dialogcont {
      margin-top: 16px;
      font-size: 13px;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #8c8f9a;
      line-height: 20px;
    }
    .dialogimg {
      text-align: center;
      padding: 10px;
      margin-top: 11px;
      border-radius: 2px;
      img {
        display: inline-block;
        max-width: 100%;
      }
    }
    .uploadinglist {
      padding: 21px 42px;
      position: relative;
      .uploadinglisttime {
        position: absolute;
        top: 21px;
        right: 42px;
        font-size: 12px;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #99a9ba;
      }
      .uploadinglistImg {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        text-align: center;
        background: var(--themeColor);
        position: absolute;
        top: 21px;
        left: 12px;
        line-height: 20px;
      }
      .uploadinglisttitle {
        width: calc(100% - 200px);
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 900;
        color: #2c3a50;
        letter-spacing: 2px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .uploadinglistcont {
        margin-top: 14px;
        font-size: 12px;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #8c8f9a;
        line-height: 16px;
        letter-spacing: 2px;
      }
    }
  }
}
</style>
